// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#seed {\n    position:relative;\n    z-index:1;\n    width: 100%;\n    margin: 3% 25% 0% 0%;\n    height: 100px;\n    border-radius: 3px;\n}\n\n.wallet-seed{\n    position:relative;\n    z-index:1;\n    margin: 1% 6% 1% 4%;\n}", ""]);
// Exports
module.exports = exports;
